import React, { useContext } from 'react';
import { Grid, Typography, Button, IconButton, Chip } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Share from '@material-ui/icons/Share';
import copy from 'copy-to-clipboard';
import { I18nContext } from 'translations';
import { modalMessage } from 'utils';
import { companyStatusBadge, routeStatusBadge } from 'utils/deliveryRoute';

export default function RouteHeader({ route, onClickBack }) {
  const { translate } = useContext(I18nContext);
  // company_status is the reading derived for the company_id in the URL — what is happening
  // to ITS packages, not to the whole shared route. It is null without a company filter and
  // on a terminal or relaunched route, where everyone must read the same route-level status.
  const statusBadge =
    companyStatusBadge(route.company_status, translate) || routeStatusBadge(route.status_cd, translate);

  const shareLink = () => {
    const url = `${window.location.origin}/bookings/${route.booking_id}`;
    copy(url);
    modalMessage(
      '',
      translate('app.booking.linkToShareSuccessfullyCopied'),
      'success',
      translate('continue'),
      true
    );
  };

  return (
    <Grid container justify="space-between" alignItems="flex-start" data-testid="route-header" style={{ marginBottom: 20 }}>
      <Grid item>
        <Grid container alignItems="center" wrap="nowrap">
          <IconButton onClick={onClickBack} size="small" style={{ marginRight: 4 }} aria-label={translate('back')}>
            <ArrowBackIcon />
          </IconButton>
          <div>
            <Typography component="div" variant="h6" style={{ fontWeight: 700, lineHeight: 1.2 }}>
              {route.description}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {route.company?.name} · {route.created_at_date} · {route.created_at_time}
            </Typography>
          </div>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container alignItems="center" spacing={1}>
          <Grid item>
            <Chip
              size="small"
              data-testid="route-status-badge"
              label={statusBadge.label}
              style={{
                backgroundColor: `${statusBadge.color}1f`,
                color: statusBadge.color,
                fontWeight: 700,
                textTransform: 'uppercase',
                fontSize: 11,
                letterSpacing: 0.4,
              }}
            />
          </Grid>
          <Grid item>
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={shareLink}
              style={{ borderRadius: 20, textTransform: 'uppercase', fontWeight: 700, fontSize: 12, padding: '6px 16px' }}
            >
              <Share fontSize="small" style={{ marginRight: 6 }} />
              {translate('app.booking.btn.share')}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
